export default __webpack_public_path__ + "static/media/Hair_9_M_C5.e201ce48.svg";